(() => {
  if (window.__oneLuxuryMadeToOrderCardRouting) return;
  window.__oneLuxuryMadeToOrderCardRouting = true;

  const CARD_SELECTOR = '.m-product-card';
  const CTA_SELECTOR = 'a[data-availability-cta="made_to_order"]';

  const getSiteOrigin = () => {
    try {
      const origin = new URL(document.baseURI).origin;
      if (origin && origin !== 'null') return origin;
    } catch (error) {
      return window.location.origin;
    }
    return window.location.origin;
  };

  const getVariantId = (card) => {
    const input = card && card.querySelector('input[name="id"]');
    const value = input && (input.value || input.getAttribute('value'));
    return /^\d+$/.test(String(value || '')) ? String(value) : '';
  };

  const getProductHandle = (card) => {
    const picker = card && card.querySelector('[data-pcard-variant-picker][data-product-handle]');
    if (picker && picker.dataset.productHandle) return picker.dataset.productHandle;

    const handleNode = card && card.querySelector('[data-product-handle]');
    return handleNode && handleNode.dataset.productHandle ? handleNode.dataset.productHandle : '';
  };

  const getRoutesRoot = () => {
    const rawRoot =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.root) ||
      '/';
    const trimmed = String(rawRoot).replace(/^\/+|\/+$/g, '');
    return trimmed ? `/${trimmed}/` : '/';
  };

  const syncCard = (card) => {
    if (!(card instanceof Element)) return;

    const links = card.querySelectorAll(CTA_SELECTOR);
    if (!links.length) return;

    const variantId = getVariantId(card);
    if (!variantId) return;

    const fallbackHandle = getProductHandle(card);
    const siteOrigin = getSiteOrigin();

    links.forEach((link) => {
      try {
        const destination = new URL(link.getAttribute('href') || '', siteOrigin);
        destination.searchParams.set('variant', variantId);

        const handle = destination.searchParams.get('handle') || fallbackHandle;
        if (handle) {
          const selectedProductUrl = new URL(
            `${getRoutesRoot()}products/${encodeURIComponent(handle)}`,
            siteOrigin
          );
          selectedProductUrl.searchParams.set('variant', variantId);
          destination.searchParams.set('url', selectedProductUrl.href);
        }

        const href =
          destination.origin === siteOrigin
            ? `${destination.pathname}${destination.search}${destination.hash}`
            : destination.href;
        link.setAttribute('href', href);
      } catch (error) {
        console.warn('1Luxury made-to-order card routing could not update a link.', error);
      }
    });

    card.querySelectorAll('[data-one-luxury-availability]').forEach((node) => {
      node.dataset.availabilityVariantId = variantId;
    });
  };

  const scan = (root) => {
    if (!root) return;
    if (root instanceof Element && root.matches(CARD_SELECTOR)) syncCard(root);
    if (root.querySelectorAll) root.querySelectorAll(CARD_SELECTOR).forEach(syncCard);
  };

  const scheduleCardSync = (target) => {
    const card = target && target.closest ? target.closest(CARD_SELECTOR) : null;
    if (!card) return;
    window.setTimeout(() => syncCard(card), 0);
  };

  const start = () => {
    scan(document);

    const observer = new MutationObserver((records) => {
      const cards = new Set();

      records.forEach((record) => {
        if (record.type === 'attributes') {
          const card = record.target.closest && record.target.closest(CARD_SELECTOR);
          if (card) cards.add(card);
          return;
        }

        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(CARD_SELECTOR)) cards.add(node);
          node.querySelectorAll(CARD_SELECTOR).forEach((card) => cards.add(card));
        });
      });

      cards.forEach(syncCard);
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['value'],
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const madeToOrderLink = event.target.closest && event.target.closest(CTA_SELECTOR);
      if (madeToOrderLink) {
        syncCard(madeToOrderLink.closest(CARD_SELECTOR));
        return;
      }

      const option =
        event.target.closest &&
        event.target.closest('.m-product-option--node__label, [data-pcard-variant-picker] .combined-variant');
      if (option) scheduleCardSync(option);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      if (event.target.closest && event.target.closest('[data-pcard-variant-picker]')) {
        scheduleCardSync(event.target);
      }
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('page:loaded', () => scan(document));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
